import { render, staticRenderFns } from "./DigitalClock.vue?vue&type=template&id=2f925488&scoped=true&"
import script from "./DigitalClock.vue?vue&type=script&lang=js&"
export * from "./DigitalClock.vue?vue&type=script&lang=js&"
import style0 from "./DigitalClock.vue?vue&type=style&index=0&id=2f925488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f925488",
  null
  
)

export default component.exports